export default "<template>\r\n  <v-file-input show-size label=\"File input\"></v-file-input>\r\n</template>\r\n";